/* eslint-disable no-useless-escape */
export const TOOLS = {
  uniqueID: () => {
    return (
      "_" +
      Math.random()
        .toString(36)
        .substr(2, 9)
    );
  },

  slugify: text => {
    const a = "àáäâãèéëêìíïîòóöõôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;";
    const b = "aaaaaeeeeiiiiooooouuuuncsyoarsnpwgnmuxzh------";
    const p = new RegExp(a.split("").join("|"), "g");

    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
      .replace(/&/g, "-and-") // Replace & with 'and'
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  },

  onlyNumbers: value => value.replace(/(^-{1})|(\d)|(\D)/g, "$1$2"),

  formatReal: (int, mask = false) => {
    //formatReal recebe int que receberá virgula
    let tmp = int;
    tmp = int + "";
    let neg = false;
    if (tmp.indexOf("-") === 0) {
      neg = true;
      tmp = tmp.replace("-", "=");
    }

    if (tmp.length === 1 && !mask) tmp = "0" + tmp;

    console.log(tmp)
    tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
    if (tmp.length > 2) tmp = tmp.replace(/([1-9]{3}),([0-9]{2}$)/g, ".$1,$2");

    if (tmp.length > 9)
      tmp = tmp.replace(/([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g, ".$1.$2,$3");

    if (tmp.length > 12)
      tmp = tmp.replace(
        /([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g,
        ".$1.$2.$3,$4"
      );

    if (tmp.length > 15)
      tmp = tmp.replace(
        /([0-9]{3}).([0-9]{3}).([0-9]{3}).([0-9]{3}),([0-9]{2}$)/g,
        ".$1.$2.$3.$4,$5"
      );

    if (tmp.indexOf(".") === 0) tmp = tmp.replace(".", "");
    if (tmp.indexOf(",") === 0) tmp = tmp.replace(",", "0,");

    return neg ? "-" + tmp : tmp;
  },

  formatTime: (int, mask = false) => {
    //formatTime recebe int que receberá virgula

    let tmp = int.toString().slice(0, 4);
    tmp = parseInt(tmp) + "";

    if (tmp.length === 1 && !mask) tmp = "0" + tmp;

    // console.log(tmp.length)

    // tmp = tmp.replace(/([0-9]{2})$/g, ":$1")
    if (tmp.length < 5) tmp = tmp.replace(/([0-9]{2})$/g, ":$1")
    if (tmp.length > 4) tmp = tmp.replace(/([0-9]{2}):([0-9]{2}$)/g, "$1:$2")

    if (tmp.indexOf(":") === 0) tmp = tmp.replace(":", "00:");

    return tmp.slice(0, 5);
    // return tmp;

  }

};
